// extracted by mini-css-extract-plugin
export var certificates = "certificates__O_GX";
export var descriptionHeader = "description-header__LYc3";
export var faq = "faq__trey";
export var heading = "heading__E2F6";
export var link = "link__qiT2";
export var paragraph = "paragraph__ZdhE";
export var rating = "rating__TasA";